import type { CryptoAsset } from '@/types/WalletTypes';
import type { ICryptoAssetProvider } from './ICryptoAssetProvider';

export class CryptoAssetProviderResolver {
  private providers: ICryptoAssetProvider[];

  constructor(providers: ICryptoAssetProvider[]) {
    this.providers = providers;
  }

  resolve(cryptoAsset: CryptoAsset): ICryptoAssetProvider | null {
    return this.providers.find((provider) => provider.supports(cryptoAsset)) ?? null;
  }

  requireProvider(cryptoAsset: CryptoAsset): ICryptoAssetProvider {
    const provider = this.resolve(cryptoAsset);

    if (!provider) {
      throw new Error(`No CryptoAsset provider registered for ${cryptoAsset.routingKey.value}`);
    }
    return provider;
  }
}
